import React from "react";
import { Link } from "react-router-dom";
import {
  UncontrolledCollapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";
import logo from "../../assets/img/brand/logo-white.png";
import logoPurple from "assets/img/brand/logo-purple.png";
import i18n from "../../variables/translations/i18n";
import nlFlag from "assets/img/icons/common/nl.png";
import enFlag from "assets/img/icons/common/en.png";
import i18next from "i18next";
import urls from "urls";

class AuthNavbar extends React.Component {
  changeLanguage = (lang) => {
    i18next.changeLanguage(lang);
  };
  getActiveFlag() {
    if (i18next.language === "nl") return nlFlag;
    else return enFlag;
  }
  render() {
    const langs = [
      { label: "English", value: "en", icon: enFlag },
      { label: "Nederlands", value: "nl", icon: nlFlag },
    ];
    return (
      <>
        <Navbar
          className="navbar-horizontal navbar-main navbar-dark navbar-transparent"
          expand="lg"
          id="navbar-main"
        >
          <Container>
            <NavbarBrand to="/" tag={Link}>
              <img alt="logo" src={logo} />
            </NavbarBrand>
            <button
              aria-controls="navbar-collapse"
              aria-expanded={false}
              aria-label="Toggle navigation"
              className="navbar-toggler"
              data-target="#navbar-collapse"
              data-toggle="collapse"
              id="navbar-collapse"
              type="button"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <UncontrolledCollapse
              className="navbar-custom-collapse"
              navbar
              toggler="#navbar-collapse"
            >
              <div className="navbar-collapse-header">
                <Row>
                  <Col className="collapse-brand" xs="6">
                    <Link to="/admin/dashboard">
                      <img alt="logo" src={logoPurple} />
                    </Link>
                  </Col>
                  <Col className="collapse-close" xs="6">
                    <button
                      aria-controls="navbar-collapse"
                      aria-expanded={false}
                      aria-label="Toggle navigation"
                      className="navbar-toggler"
                      data-target="#navbar-collapse"
                      data-toggle="collapse"
                      id="navbar-collapse"
                      type="button"
                    >
                      <span />
                      <span />
                    </button>
                  </Col>
                </Row>
              </div>
              <Nav className="mr-auto" navbar>
                <NavItem>
                  <NavLink to="/" tag={Link}>
                    <span className="nav-link-inner--text">Home</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to={urls.pricing} tag={Link}>
                    <span className="nav-link-inner--text">
                      {i18n.t("nav_prijzen")}
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to={urls.contact} tag={Link}>
                    <span className="nav-link-inner--text">
                      {i18n.t("nav_contact")}
                    </span>
                  </NavLink>
                </NavItem>
              </Nav>
              <Nav className="align-items-lg-center ml-lg-auto" navbar>
                {langs.map((item, i) => {
                  return (
                    <a
                      onClick={() => this.changeLanguage(item.value)}
                      href="#"
                      key={i}
                    >
                      <img
                        src={item.icon}
                        style={{ width: "22px", marginRight: "1rem" }}
                      />
                    </a>
                  );
                })}
              </Nav>
              <hr className="d-lg-none" />
            </UncontrolledCollapse>
          </Container>
        </Navbar>
      </>
    );
  }
}

export default AuthNavbar;
